<template>
    <div id="signin_wrapper">
        <v-dialog 
            v-model="activateUserDialog" 
            width="40%"
            elevation="8"
            persistent>
                <ActivateUserConfirmation 
                    :selectedUser="selectedUser"
                    @updateSwitchState="updateSwitchState"
                    @closeActivateDialog="closeActivateDialog" />
        </v-dialog> 

        <v-form v-model="admin_user_valid" ref="admin_user">                            
            <v-row>
                <v-col>
                    <div v-if="!user_not_found">
                        <div class="d-block sansation mb-1">Search for a client</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="search"
                                class="mb-6"
                                persistent-hint
                                hint="Search for an existing user, then click below to add them."
                                color="primary darken-1" 
                                single-line 
                                append-icon="mdi-magnify">
                            </v-text-field>
                            
                            <v-data-table
                                v-if="search"
                                :headers="users_headers"
                                :items="users"
                                :items-per-page="10"
                                sort-by="created_date"
                                class="elevation-1"
                                style="cursor: pointer"
                                :search="search"
                                @click:row="selectedUserFromSearch">

                                <template v-slot:[`item.full_name`]="{ item }">
                                    <div class="text-start">{{ item.full_name }}</div>
                                </template>

                                <template v-slot:[`item.phone`]="{ item }">
                                    <div class="text-start">{{ item.phone }}</div>
                                </template>

                                <template v-slot:[`item.user_email`]="{ item }">
                                    <div class="text-start">{{ item.user_email }}</div>
                                </template>

                                <template v-slot:[`item.created_date`]="{ item }">
                                    <div class="text-start">{{ item.created_date }}</div>
                                </template>

                                <template v-slot:[`item.is_active`]="{ item }">
                                    <div class="text-end">{{ item.is_active ? 'Yes' : 'No' }}</div>
                                </template>

                            </v-data-table>
                        
                            <div v-if="search" class="mt-3">
                                Can't find who you're looking for: <a @click="createNewUser()">create a new user</a>
                            </div>

                            <div v-if="showSelectedUser" class="my-3 d-block">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="sansation">
                                                <th class="text-left">
                                                    First Name
                                                </th>
                                                <th class="text-left">
                                                    Last Name
                                                </th>
                                                <th class="text-left">
                                                    Email Address
                                                </th>
                                                <th class="text-left">
                                                    Is Active
                                                </th>
                                                <th class="d-flex justify-end align-center mr-0 pr-0">
                                                    <div class="d-inline mr-1">Generate Email:</div>
                                                    <v-checkbox
                                                        v-model="generate_email_on_add"
                                                        hide-details
                                                        color="primary"
                                                        class="d-inline ma-0 pa-0">
                                                    </v-checkbox>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ admin_firstname }}</td>
                                                <td>{{ admin_lastname }}</td>
                                                <td>{{ admin_email }}</td>
                                                <td>
                                                    <div v-if="admin_active">Yes</div>
                                                    <v-switch
                                                        v-if="!admin_active"
                                                        v-model="switch_state"
                                                        hide-details
                                                        color="primary"
                                                        class="d-inline ma-0 pa-0"
                                                        @click="activateUserDialog = true">
                                                    </v-switch>
                                                </td>
                                                <td class="text-end pr-0">
                                                    <v-btn 
                                                        color="primary" 
                                                        class="mr-3 d-inline"
                                                        outlined 
                                                        id="login_btn" 
                                                        @click="showSelectedUser = false">
                                                        reset
                                                    </v-btn>
                                                    <v-tooltip left color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn 
                                                                v-if="!admin_active"
                                                                color="grey lighten-2" 
                                                                class="d-inline grey--text lighten-2 mr-1"
                                                                id="login_btn"
                                                                v-bind="attrs"
                                                                v-on="on">
                                                                Add
                                                            </v-btn>
                                                        </template>
                                                        <span>The user must be active to add them to a project.</span>
                                                    </v-tooltip>
                                                    <v-btn 
                                                        v-if="admin_active"
                                                        color="primary" 
                                                        class="d-inline mr-1"
                                                        id="login_btn" 
                                                        @click="addProjectAdmin()">
                                                        Add
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-divider></v-divider>
                            </div>
                        </div>
                        
                    </div>
                    <div v-if="user_not_found" style="width: 50%">
                        <div class="d-block sansation mb-1">First Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="admin_firstname" 
                                solo 
                                :rules="firstnameRules"
                                required>
                            </v-text-field>
                        </div>

                        <div class="d-block sansation mb-1">Last Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="admin_lastname" 
                                solo 
                                :rules="lastnameRules"
                                required>
                            </v-text-field>
                        </div>
                        
                        <div class="d-block sansation mb-1">Email</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model.lazy="admin_email" 
                                solo 
                                :rules="emailRules" 
                                required>
                            </v-text-field>                                    
                        </div>

                        <div class="d-flex d-block justify-end align-center mt-n3 mb-4 mr-0 pr-0">
                            <div class="d-inline mr-1">Generate Email:</div>
                            <v-checkbox
                                v-model="generate_email_on_add"
                                hide-details
                                color="primary"
                                class="d-inline ma-0 pa-0 mr-n2">
                            </v-checkbox>
                        </div>

                        <div class="mt-3 d-block d-flex">
                            <a @click="goBack()">
                                <v-icon color="primary" class="mr-1">mdi-ray-end-arrow</v-icon> go back
                            </a>
                            <v-spacer></v-spacer>
                            <v-btn 
                                color="primary" 
                                class="mr-3 d-inline"
                                outlined 
                                id="login_btn" 
                                @click="resetClear" >
                                reset
                            </v-btn>
                            <v-btn 
                                color="primary" 
                                class="d-inline"
                                dark 
                                id="login_btn" 
                                @click="addProjectAdmin()" >
                                {{ submit_text }}
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    import ActivateUserConfirmation from './dialogs/ActivateUserConfirmation.vue'

    export default {
        name: 'AdminUser',

        components: {
            ActivateUserConfirmation
        },

        props: {
            project: Object,
            userData: Object,
            adminUserDialog: Boolean,
            resetCreateNewUser: Boolean,
            refreshUsers: Function,
        },

        data () {
            return {
                users: [],
                admin_user_valid: false,
                user_not_found: false,
                users_headers: [
                    { text: 'Full Name',    value: 'full_name',    align: 'start',   sortable: true },
                    { text: 'Phone',        value: 'phone',        align: 'left',    sortable: true },
                    { text: 'Email',        value: 'user_email',   align: 'left',    sortable: true },
                    { text: 'Date Created', value: 'created_date', align: 'left',    sortable: true },
                    { text: 'Active',       value: 'is_active',    align: 'end',     sortable: true },                
                ],
                filteredUsers: [],
                search: '',
                submit_text: 'Submit',
                firstnameRules: [
                    (v) => !!v || 'First Name is required'
                ],
                lastnameRules: [
                    (v) => !!v || 'Last Name is required'
                ],
                emailRules: [
                    (v) => !!v || 'Email is required',
                    (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format'
                ],
                admin_userid: '',
                admin_firstname: '',
                admin_lastname: '',
                admin_email: '',
                admin_usertype: '',
                admin_active: Boolean,
                selectedUser: {},
                showSelectedUser: false,
                localData: { ...this.userData },
                generate_email_on_add: true,
                activateUserDialog: false,
                switch_state: false
            }
        },
        
        watch: {
            project(val) {
                this.resetClear()
            },
            resetCreateNewUser(val) {
                if ( val ) {
                    this.resetClear()
                }
            },
            userData: {
                handler(newValue) {
                    this.localData = { ...newValue };
                    this.getUsers()
                },
                deep: true,
                immediate: true
            },
            selectedUser: {
                handler(newValue) {
                    this.admin_active = newValue.is_active
                },
                deep: true,
                immediate: true
            }
        },

        methods: {
            getUsers: async function () {
                try {
                    const get_users = await axios.get(`${appUrls.api}/api/admin/users`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( get_users.data.outcome ) {
                        // console.log(res.data.users)
                        this.users = get_users.data.users;
                        let i = 0;
                        for( let user of this.users ) {
                            this.users[i].full_name = `${user.first_name} ${user.last_name}`;
                            this.users[i].user_email = user.user_email
                            this.users[i].created_date = user.created_date.substr(0, 10);
                            i++;
                        }

                        this.users = this.users.filter(user => 
                            user.roles.some(role => this.localData.userGroup.includes(role))
                        )
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            createNewUser: async function () {
                this.resetClear()
                this.user_not_found = true
            },

            selectedUserFromSearch: async function ( item ) {
                this.admin_userid = item.user_id
                this.admin_firstname = item.first_name
                this.admin_lastname = item.last_name
                this.admin_email = item.user_email
                this.admin_active = item.is_active
                this.admin_usertype = item.user_type
                this.admin_user_valid = true

                this.showSelectedUser = true

                this.selectedUser = {
                    user_id: item.user_id,
                    is_active: item.is_active
                }
                // this.addProjectAdmin()
            },

            addProjectAdmin: async function () {
                try {
                    // console.log(this.admin_userid, this.admin_firstname, this.admin_lastname, this.admin_email)
                    if ( this.admin_user_valid ) {
                        const add_project_admin = await axios.put(`${appUrls.api}/api/admin/add_project_admin`, { // make changes in server - removed parentUserID
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                parentUserId: this.project.user_id,
                                projectId: this.project.project_id,
                                admin_userid: this.admin_userid,
                                admin_firstname: this.admin_firstname,
                                admin_lastname: this.admin_lastname, 
                                admin_email: this.admin_email,
                                admin_usertype: this.localData.userType,
                                admin_active: this.admin_active,
                                generate_email: this.generate_email_on_add
                            }
                        })

                        // console.log(add_project_admin.data)
                        if ( add_project_admin.data.outcome ) {
                            this.$emit('adminUserDialog', false)
                            // console.log('secondary_users emit refresh')
                            this.$emit('refreshUsers', this.project.project_id, add_project_admin.data.message)  // make changes in "refreshUsers" method - removed parentUserID
                            this.resetClear()
                        } else {
                            // console.log(add_project_admin.data.message)
                            this.$emit('refreshUsers', this.project.project_id, add_project_admin.data.message)  // make changes in "refreshUsers" method - removed parentUserID
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                    // this.$emit("addUserFeedback", { outcome: false, message: error });
                }
            },
            
            resetClear () {
                this.search = ''
                this.admin_userid = ''
                this.admin_firstname = ''
                this.admin_lastname = '' 
                this.admin_email = ''
                this.admin_active = ''
                this.admin_usertype = ''
                this.selectedUser = {}
            },

            goBack() {
                this.user_not_found = false
                this.showSelectedUser = false
            },

            closeActivateDialog: function ( val ) {
                this.activateUserDialog = val
            },

            updateSwitchState: function ( val ) {
                this.switch_state = val
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #signin_wrapper {
        width: 100%;
        height: 100%;
    }
    #login {
        min-width: 100%;
        max-width: 100%;
        margin: 2% auto;
        padding: 9%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    #login_btn {
        padding: 4px 20px;
        /* width: 36%; */
        font-size: 1.2em !important;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    .signin_title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.6rem !important;
        letter-spacing: 0.05rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminUser.vue